export type CategoryItem = {
  key: string;
  label: string;
  icon: string;
  desc: string;
};

export const categories: CategoryItem[] = [
  { key: "电影", label: "电影", icon: "ri-movie-2-line", desc: "院线大片与经典佳作，一网打尽" },
  { key: "电视剧", label: "电视剧", icon: "ri-live-line", desc: "热播剧集与口碑长剧，追剧不停" },
  { key: "综艺", label: "综艺", icon: "ri-mic-line", desc: "音乐、竞技与户外真人秀全收录" },
  { key: "动漫", label: "动漫", icon: "ri-palette-line", desc: "国漫与海外动画精选推荐" },
  { key: "纪录片", label: "纪录片", icon: "ri-camera-lens-line", desc: "自然、人文与历史纪实影像" },
  { key: "影评", label: "影评", icon: "ri-chat-quote-line", desc: "深度影评与观影观点分享" },
];

export const newsCategories: CategoryItem[] = [
  { key: "行业新闻", label: "行业新闻", icon: "ri-newspaper-line", desc: "影视圈最新动态与市场观察" },
  { key: "影评", label: "影评", icon: "ri-chat-quote-line", desc: "深度影评与观影观点分享" },
  { key: "幕后", label: "幕后", icon: "ri-clapperboard-line", desc: "制作花絮与主创幕后故事" },
];

export const filterCountries = ["全部", "中国", "美国", "英国", "法国"];
export const filterYears = ["全部", "2025", "2024", "2023"];
export const filterGenres = ["全部", "科幻", "悬疑", "惊悚", "犯罪", "剧情", "奇幻", "古装", "都市", "爱情", "青春", "医疗", "年代", "文艺", "音乐", "竞技", "美食"];
export const sortOptions = [
  { key: "rating", label: "热门程度" },
  { key: "year", label: "上映时间" },
  { key: "title", label: "名称排序" },
];